// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".m-amp-article__img{width:100%}.m-amp-ad__wrapper{margin-bottom:15px;margin-top:15px;text-align:center;width:100%;padding-top:16px;padding-bottom:16px;background-color:#e2e2e2}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
